<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="prescriptionInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-vet-prescription :vetPrescriptionInfo="prescriptionInfo" />
        </div>
      </el-card>
      <div>
        <x-tab
          v-model="tabName"
          :tabs="tabs"
          :query="tabParams"
          :params="tabParams"
        />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small">
        重新加载
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.replenish-detail {
  margin-top: 20px;
}
</style>

<script>
import detailItemList from './__detail_prescription.vue';
import warehouseVetPrescription from '../../../../components/business/warehouseVetPrescription.vue';

export default {
  components: {
    warehouseVetPrescription,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.prescriptionInfo) {
        return {};
      }
      return {
        guid: this.prescriptionInfo.guid,
        prescriptionGuid: this.prescriptionInfo.guid,
        storeGuid: this.prescriptionInfo.storeGuid
      }
    },
    tabs() {
      if (!this.prescriptionInfo) {
        return [];
      }
      let tabList = [
        {
          name: "prescription-rp-list",
          label: "处方笺详情",
          component: detailItemList,
          interval: true,
        },
      ]
      return tabList;
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      prescriptionInfo: null,
      printLoading: false,
      cancelLoading: false,
      tabName: ""
    }
  },
  methods: {
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.prescriptionInfo = null;
      return this.requestApi('biz.warehouse.vet.prescription.info.detail', {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
        autoIssue: 1
      }).then((resp) => {
        this.prescriptionInfo = resp.data;
      }).catch((err) => {
        this.errorMsg = (err && err.msg) || (err && err.message)
          || '连接服务器失败，请检查网络';
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
}
</script>